import { Unit } from "./Unit";
import { UnitGroup } from "./UnitGroup";

export class VolumeUnits extends UnitGroup {
    private static _singleton: VolumeUnits;

    public static readonly IMP_GALLON = new Unit("IG", "Imperial Gallons");
    public static readonly LITER = new Unit("L", "Liters");
    public static readonly US_GALLON = new Unit("UG", "US Gallons");
    
    constructor() {
        const units = [ VolumeUnits.IMP_GALLON, VolumeUnits.LITER, VolumeUnits.US_GALLON ];
        super(units, "volume_company_um", "volume_functional_um");
    }

    public static get singleton(): VolumeUnits {
        if (this._singleton == null) {
            this._singleton = new VolumeUnits();
        }
        return this._singleton;
    }
}
